module.exports = __webpack_public_path__ + "img/why_does_this_matter_illustration.61ece85e.svg";